<template>
    <template v-if="hasCoverage || hasAssignment">
        <span v-if="hasCoverage" :class="['tag', 'is-small', coverageTagClass]">
            {{ coverageLabel }}
        </span>
        <span v-if="hasAssignment" :class="['tag', 'is-light', 'is-small', 'has-text-grey', { 'ml-1': hasCoverage }]">
            {{ assignmentLabel }}
        </span>
    </template>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import { getRoundMarkerTagClass, getRoundMarkerTranslationKey, RoundMarker } from "./Managing/dropZoneItems";

    const props = defineProps<{
        from: RoundMarker | null;
        to: RoundMarker | null;
        includesThirdPlace?: boolean;
        assignmentType?: number;
    }>();

    const ASSIGNMENT_KEYS: Record<number, string> = {
        2: "short_assignment_type.first_half",
        4: "short_assignment_type.second_half",
        8: "short_assignment_type.first_quarter",
        16: "short_assignment_type.second_quarter",
        32: "short_assignment_type.third_quarter",
        64: "short_assignment_type.fourth_quarter",
    };

    const hasCoverage = computed(() => props.from !== null || props.to !== null);

    const hasAssignment = computed(() => !!props.assignmentType && props.assignmentType > 1);

    const coverageTagClass = computed(() => getRoundMarkerTagClass(props.from, props.to));

    const coverageLabel = computed((): string => {
        const from = props.from;
        const to = props.to;

        if (props.includesThirdPlace && from === "final" && to === "final") {
            return translate("admin_schedule_manage.final_with_third_place") ?? "";
        }

        const label = from === to ? formatRoundMarker(from) : `${formatBoundary(from)} → ${formatBoundary(to)}`;

        if (props.includesThirdPlace) {
            return `${label} + ${formatRoundMarker("third_place")}`;
        }

        return label;
    });

    const assignmentLabel = computed((): string => {
        const key = props.assignmentType ? ASSIGNMENT_KEYS[props.assignmentType] : undefined;
        return key ? (translate(key) ?? "") : "";
    });

    function formatBoundary(marker: RoundMarker | null): string {
        return marker === null ? "∞" : formatRoundMarker(marker);
    }

    function formatRoundMarker(marker: RoundMarker | null): string {
        if (marker === null) {
            return "";
        }
        return translate(getRoundMarkerTranslationKey(marker)) ?? marker;
    }
</script>
